module.exports = __webpack_public_path__ + "static/media/doctorf.eb076175.png";